import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

export interface WorkspaceHubNavItem {
  /** Visible label in the workspace-local menu. */
  label: string;
  /** Absolute route; omitted for future capabilities that must not navigate. */
  url?: string;
  /** Only the Overview destination matches exactly; the rest match child routes too. */
  exact?: boolean;
  /** Short future-capability label, e.g. `Coming soon`. Never an entitlement label. */
  futureLabel?: string;
}

/**
 * Concept B — the workspace-local menu shown at the top of every Workspace screen.
 * Audit and Backups are future Teams capabilities, not Enterprise entitlements, so
 * they carry a `Coming soon` label and no route.
 */
export const WORKSPACE_HUB_NAV_ITEMS: readonly WorkspaceHubNavItem[] = [
  { label: 'Overview', url: '/teams', exact: true },
  { label: 'Monitor', url: '/teams/monitor' },
  { label: 'Members', url: '/teams/members' },
  { label: 'Audit', futureLabel: 'Coming soon' },
  { label: 'Backups', futureLabel: 'Coming soon' },
  { label: 'Settings', url: '/teams/workspace' }
];

@Component({
  selector: 'app-workspace-hub-nav',
  templateUrl: './workspace-hub-nav.component.html',
  styleUrls: ['./workspace-hub-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WorkspaceHubNavComponent {
  public readonly items = WORKSPACE_HUB_NAV_ITEMS;

  constructor(private router: Router) {}

  public isActive(item: WorkspaceHubNavItem): boolean {
    if (!item.url) {
      return false;
    }
    const url = (this.router.url || '').split('?')[0].split('#')[0];
    return item.exact ? url === item.url : url === item.url || url.startsWith(`${item.url}/`);
  }

  public navigate(item: WorkspaceHubNavItem): void {
    if (!item.url) {
      return;
    }
    this.router.navigateByUrl(item.url);
  }
}
